import React from 'react';
import PropTypes from 'prop-types';

const DownArrow = ({color = 'currentColor', width}) => {
  return (
    <svg width={width} viewBox="0 0 1024 1024">
      <path fill={color} d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"/>
    </svg>
  )
}

DownArrow.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string
};

export default DownArrow;
